import MyPOsConstants from '@/store/modules/myPOs/constants';
import PurchaseOrderService from '@/services/purchaseOrderService';

const purchaseOrderService = new PurchaseOrderService();
export default {
  [MyPOsConstants.actionTypes.loadMyPurchaseOrders]({
    commit,
    state,
  }) {
    const {
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
    } = state.paginationInfo;
    const {
      filterQuery,
    } = state;

    commit(MyPOsConstants.mutationTypes.setIsLoading, true);

    purchaseOrderService
      .getMyPurchaseOrders({
        pageNumber,
        pageSize,
        sortBy,
        sortOrder,
        filterQuery,
      })
      .then((apiResponse) => {
        if (apiResponse) {
          if (apiResponse === null) {
            commit(MyPOsConstants.mutationTypes.setMyPurchaseOrders, []);
            commit(MyPOsConstants.mutationTypes.setMyPurchaseOrdersTotal, 0);
          } else {
            commit(MyPOsConstants.mutationTypes.setMyPurchaseOrders, apiResponse.items);
            commit(MyPOsConstants.mutationTypes.setMyPurchaseOrdersTotal, apiResponse.total);
          }
          commit(MyPOsConstants.mutationTypes.setIsLoading, false);
        }
      })
      .catch(() => {
        commit(MyPOsConstants.mutationTypes.setMyPurchaseOrders, []);
        commit(MyPOsConstants.mutationTypes.setMyPurchaseOrdersTotal, 0);
        commit(MyPOsConstants.mutationTypes.setIsLoading, false);
      });
  },
  [MyPOsConstants.actionTypes.updatePaginationInfo]({
    commit,
  }, paginationInfo) {
    commit(MyPOsConstants.mutationTypes.setPaginationInfoPageNumber, paginationInfo.pageNumber);
    commit(MyPOsConstants.mutationTypes.setPaginationInfoPageSize, paginationInfo.pageSize);
    commit(MyPOsConstants.mutationTypes.setPaginationInfoSortBy, paginationInfo.sortBy);
    commit(MyPOsConstants.mutationTypes.setPaginationInfoSortOrder, paginationInfo.sortOrder);
  },
  [MyPOsConstants.actionTypes.onFilterQueryChanged]({
    commit,
  }, newValue) {
    commit(MyPOsConstants.mutationTypes.setFilterQuery, newValue);
    commit(MyPOsConstants.mutationTypes.setPaginationInfoPageNumber, 1);
  },
};
